document.addEventListener('DOMContentLoaded', () => {
  // Don't run on investments, using own custom menu. See investments tax-nav.js.
  if (document.getElementById('page').classList.contains('investments')) {
    return;
  }

  document.addEventListener('click', event => {
    // Grab all the li elements
    const list = document.querySelectorAll('ul#menu-primary > li');
    const primaryMenu = document.querySelectorAll('div.primaryNav--desktop')[0];
    for (let i = 0; i < list.length; i += 1) {
      if (event.target === list[i]) {
        if (event.target.classList.contains('inactive')) {
          list.forEach(node => {
            node.classList.remove('active');
            node.classList.add('inactive');
          });
          event.target.classList.add('active');
          event.target.classList.remove('inactive');
        } else {
          event.target.classList.add('inactive');
          event.target.classList.remove('active');
        }
      } else if (primaryMenu !== event.target) {
        list[i].classList.add('inactive');
        list[i].classList.remove('active');
      }
    }
  });
});

const docReady = fn => {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};
docReady(() => {
  let activeLinkInfo = null;

  document.addEventListener('click', event => {
    const modalDivs = document.querySelectorAll('.top-nav--modal');
    const openModalDivs = document.querySelectorAll('.openModal');
    const arrows = document.querySelectorAll('.openModal svg');

    for (let i = 0; i < modalDivs.length; i += 1) {
      const modalDiv = modalDivs[i];
      const openModalDiv = openModalDivs[i];
      const arrow = arrows[i];

      if (event.target === openModalDiv) {
        if (window.getComputedStyle(modalDiv).display === 'none') {
          modalDiv.style.display = 'flex';
          if (arrow) {
            arrow.style.transform = 'rotate(180deg)';
          }
        } else {
          modalDiv.style.display = 'none';
          if (arrow) {
            arrow.style.transform = 'rotate(0deg)';
          }
        }
      } else {
        modalDiv.style.display = 'none';
        if (arrow) {
          arrow.style.transform = 'rotate(0deg)'; // Ensure arrow is rotated to 0 degrees when the modal is hidden
        }
      }

      const allLinks = modalDiv.querySelectorAll('a');

      if (event.target.tagName === 'A' && modalDiv.contains(event.target)) {
        const activeLinkText = event.target.textContent;
        const activeLinkHref = event.target.getAttribute('href');
        activeLinkInfo = {
          element: event.target,
          text: activeLinkText,
          href: activeLinkHref,
        };
      }

      allLinks.forEach(link => {
        link.classList.remove('active');
      });

      const currentBaseURL = window.location.origin;
      allLinks.forEach(link => {
        if (link.href.startsWith(currentBaseURL)) {
          link.classList.add('active');
        }
      });

      if (activeLinkInfo) {
        document.querySelector('.link').textContent = ` / ${activeLinkInfo.text}`;
      }
    }
  });

  document.querySelector('.top-nav--container--mobile').addEventListener('click', () => {
    const toggleButton = document.getElementById('primaryNav-toggle');
    if (toggleButton) {
      toggleButton.click();
    }
  });
  const topNavContainer = document.querySelector('.top-nav--container');
  const headerInner = document.querySelector('.header-inner');
  const modal = document.querySelector('.top-nav--modal');
  const arrow = document.querySelector('.openModal svg');
  const siteContent = document.querySelector('.site-content');
  let isScrolled = false;

  function updateHeaderBackground() {
    if (topNavContainer.classList.contains('scrolling') || window.scrollY === 0) {
      headerInner.style.backgroundColor = 'transparent';
      modal.style.display = 'none';
      arrow.style.transform = 'rotate(0deg)';
    } else {
      headerInner.style.backgroundColor = '#fff';
      modal.style.display = 'flex';
    }
  }

  function handleScroll() {
    const shouldAddClass = window.scrollY > 0;

    if (isScrolled !== shouldAddClass) {
      isScrolled = shouldAddClass;

      if (isScrolled) {
        topNavContainer.classList.add('scrolling');
      } else {
        topNavContainer.classList.remove('scrolling');
      }

      if (topNavContainer.classList.contains('scrolling')) {
        siteContent.classList.add('top-navigation-scrolling');
      } else {
        siteContent.classList.remove('top-navigation-scrolling');
      }

      updateHeaderBackground();
    }
    if (topNavContainer.classList.contains('scrolling')) {
      const isNotMobile = window.matchMedia('(max-width: 1024px)').matches;
      if (isNotMobile) {
        siteContent.classList.remove('top-navigation-scrolling');
      }
    }
  }

  window.addEventListener('scroll', handleScroll);
});
